module.exports = __webpack_public_path__ + "img/ZA.a685ed92.svg";